import React, { useState } from 'react';
import { SendResetPasswordCodeModal, ResetPasswordModal } from '../../components';
import { Form, Input, Button, Flex } from '../../components';
import { Typography } from 'antd';
import { ValidationErrors } from '../../constants';
import { useWatch } from 'antd/es/form/Form';

import '../../styles/login.scss';

export const LoginForm = ({
    form,
    isLoading,
    onFinish,
    handleAlternateLogin,
    handleGoogleLogin,
    showResetPasswordCodeModal,
    setShowResetPasswordCodeModal,
}) => {
    const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);

    // Watch the email and password fields to determine if there is input
    const email = useWatch('email', form);
    const password = useWatch('password', form);
    const hasInput = !!email || !!password;

    return (
        <div className="login-container">
            <div className="login-form-wrapper">
                <div className="logo"></div>
                <Typography.Title level={4}>Sign In</Typography.Title>
                <Form
                    name="login"
                    initialValues={{ remember: true }}
                    style={{ maxWidth: 400 }}
                    onFinish={onFinish}
                    form={form}
                >
                    <Form.Item name="email" rules={[{ required: true, message: ValidationErrors.email }]}>
                        <Input placeholder="Email" />
                    </Form.Item>
                    <Form.Item name="password" rules={[{ required: true, message: ValidationErrors.password }]}>
                        <Input.Password placeholder="Password" />
                    </Form.Item>
                    <Form.Item>
                        <Button
                            type="primary"
                            className="button button--primary"
                            block
                            htmlType="submit"
                            loading={isLoading}
                        >
                            Sign in with RiverMeadow
                        </Button>
                    </Form.Item>

                    {/* Provider login buttons */}
                    <Form.Item>
                        <Button
                            onClick={() => handleAlternateLogin()}
                            icon={<img src="/img/icon_login_microsoft.png" />}
                            block
                        >
                            {hasInput ? 'Sign in with Microsoft AD' : 'Sign in with Microsoft Entra ID'}
                        </Button>
                    </Form.Item>
                    <Form.Item>
                        <Button
                            onClick={() => handleGoogleLogin()}
                            icon={<img src="/img/icon_login_google.png" />}
                            block
                        >
                            Sign in with Google
                        </Button>
                    </Form.Item>

                    {/* Forgot Password Link */}
                    <Flex justify="flex-end">
                        <Form.Item>
                            <a onClick={() => setShowResetPasswordCodeModal(true)}>Forgot password?</a>
                        </Form.Item>
                    </Flex>
                </Form>
            </div>
            <SendResetPasswordCodeModal
                open={showResetPasswordCodeModal}
                setShowResetPasswordModal={setShowResetPasswordModal}
                onCancel={() => setShowResetPasswordCodeModal(false)}
            />
            <ResetPasswordModal open={showResetPasswordModal} onCancel={() => setShowResetPasswordModal(false)} />
        </div>
    );
};
